import { useSelector } from "react-redux";
import Navbar from "../../components/navbar";
import Spinner from "../../components/Spinners/Spinner";
import { useCampaignDetail } from "../reuseableEffects";

const GratitudeChallenge = () => {

  const campaignDetail = useCampaignDetail("2024061605283138016179330");
  const loading = useSelector((state) => state.user.loading);
  document.title = `${loading? "Mosquepay" : campaignDetail?.title}`;

  const campaignVideo = campaignDetail?.video_url;
  const videoID = campaignVideo ? campaignVideo.split("v=")[1] : null;

  const campaignImageURL = "https://mosquepay.org/mosquepaynew/assets/img/campaigns/";

  return (
    <div className="grid gap-10 pt-10 pb-32">
      <Spinner loading={useSelector((state) => state.user).loading} />
      <Navbar />
      <div className="grid grid-cols-1 md:grid-cols-12">
        <p className="ubuntu-font font-semibold text-lg  px-4 md:px-12 md:col-span-12 mb-4">
          {campaignDetail?.title}
        </p>
        <div className="w-full px-4 md:px-12 md:col-span-9">
          <div className="mb-6">
            {campaignDetail?.video_url === "" ? (
              <img
                src={campaignImageURL + campaignDetail?.image}
                alt=""
                className="aspect-video md:aspect-auto md:h-[300px] w-full object-cover rounded"
              />
            ) : (
              <iframe
                className="md:aspect-auto md:h-[300px] w-full rounded-md"
                src={`https://www.youtube.com/embed/${videoID}`}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            )}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 border rounded-md p-4 my-6 text-center">
            <div className="grid">
              <div className="text-lg font-semibold">
                {campaignDetail?.amount_raise}
              </div>
              <div className="text-secondary">Campaign goal</div>
            </div>
            <div className="grid">
              <div className="text-lg font-semibold">
                {campaignDetail?.amount}
              </div>
              <div className="text-secondary">Amount raised</div>
            </div>
            <div className="grid">
              <div className="text-lg font-semibold">
                {campaignDetail?.txn_count}
              </div>
              <div className="text-secondary">Generous donors</div>
            </div>
          </div>

          <p>{campaignDetail?.campaign_story}</p>
        </div>
        <div>xjkjgfd</div>
      </div>
    </div>
  );
};

export default GratitudeChallenge;

// Amount raised, donations and goal
